(() => {
  const escapeText = (value) => String(value ?? '');

  const dialogOpeners = new WeakMap();
  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-ha-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.dataset.haOpen);
      if (dialog instanceof HTMLDialogElement) {
        dialogOpeners.set(dialog, openButton);
        dialog.showModal();
        dialog.querySelector('input, button, a')?.focus();
      }
    }

    const closeButton = event.target.closest('[data-ha-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
    }

    const galleryButton = event.target.closest('[data-ha-gallery-src]');
    if (galleryButton) {
      const gallery = galleryButton.closest('[data-ha-gallery]');
      const image = gallery?.querySelector('[data-ha-gallery-main]');
      const caption = gallery?.querySelector('[data-ha-gallery-caption]');
      const status = gallery?.querySelector('[data-ha-gallery-status]');
      if (image instanceof HTMLImageElement) {
        image.src = galleryButton.dataset.haGallerySrc;
        image.srcset = '';
        image.alt = galleryButton.dataset.haGalleryAlt || '';
        const captionText = galleryButton.dataset.haGalleryCaption || '';
        const label = galleryButton.dataset.haGalleryLabel || 'Image';
        if (caption) {
          caption.textContent = captionText;
          caption.toggleAttribute('hidden', !captionText);
        }
        if (status) status.textContent = `${label} selected.`;
        gallery?.querySelectorAll('[data-ha-gallery-src]').forEach((button) => {
          button.setAttribute('aria-current', String(button === galleryButton));
        });
      }
    }
  });

  document.querySelectorAll('dialog').forEach((dialog) => {
    dialog.addEventListener('close', () => dialogOpeners.get(dialog)?.focus());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  document.querySelectorAll('[data-ha-predictive]').forEach((input) => {
    const container = document.getElementById(input.getAttribute('aria-controls'));
    if (!container) return;
    let timer;
    let controller;

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      controller?.abort();
      const query = input.value.trim();
      if (query.length < 2) {
        container.replaceChildren();
        container.setAttribute('hidden', '');
        return;
      }

      timer = window.setTimeout(async () => {
        controller = new AbortController();
        container.removeAttribute('hidden');
        container.textContent = 'Searching…';
        try {
          const url = new URL(input.dataset.haPredictive, window.location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'product,collection');
          url.searchParams.set('resources[limit]', '6');
          const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(`Predictive search returned ${response.status}`);
          const payload = await response.json();
          const products = payload.resources?.results?.products ?? [];
          const collections = payload.resources?.results?.collections ?? [];
          container.replaceChildren();

          const renderGroup = (label, items) => {
            if (!items.length) return;
            const group = document.createElement('div');
            group.className = 'ha-predictive__group';
            const heading = document.createElement('p');
            heading.className = 'ha-eyebrow';
            heading.textContent = label;
            group.append(heading);
            items.forEach((item) => {
              const link = document.createElement('a');
              link.href = item.url;
              link.textContent = escapeText(item.title);
              group.append(link);
            });
            container.append(group);
          };

          renderGroup('Puzzles', products);
          renderGroup('Series', collections);
          if (!products.length && !collections.length) {
            const empty = document.createElement('p');
            empty.textContent = 'No close match yet. Try coastal, floral, lighthouse, or chicken.';
            container.append(empty);
          }
        } catch (error) {
          if (error.name !== 'AbortError') {
            container.textContent = 'Search suggestions are temporarily unavailable. Press Enter to search all designs.';
          }
        }
      }, 180);
    });
  });

  document.querySelectorAll('[data-ha-contact-form]').forEach((form) => {
    form.addEventListener('submit', () => {
      const button = form.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.textContent = 'Sending…';
      }
    });
  });
})();
